import React, { useEffect, useState } from 'react';
import { getRetentionCohorts, RetentionCohort } from '../../services/adminApi';

function cellColor(pct: number): string {
  if (pct >= 60) return '#22c55e';
  if (pct >= 40) return '#84cc16';
  if (pct >= 20) return '#eab308';
  if (pct > 0) return '#f97316';
  return '#e5e7eb';
}

export const RetentionTable: React.FC = () => {
  const [data, setData] = useState<RetentionCohort[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    getRetentionCohorts()
      .then(setData)
      .catch(() => setError('Failed to load retention data'))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="admin-loading">Loading retention cohorts...</div>;
  if (error) return <div className="admin-error">{error}</div>;
  if (!data.length) return <div className="admin-empty">No cohort data yet.</div>;

  return (
    <div className="admin-table-wrap">
      <table className="admin-retention-table">
        <thead>
          <tr>
            <th>Signup Week</th>
            <th>Size</th>
            {Array.from({ length: 9 }, (_, i) => (
              <th key={i}>W{i}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((cohort) => (
            <tr key={cohort.signup_week}>
              <td>{cohort.signup_week}</td>
              <td>{cohort.cohort_size}</td>
              {cohort.retention.map((pct, i) => (
                <td
                  key={i}
                  style={{
                    backgroundColor: cellColor(pct),
                    color: pct >= 20 ? 'white' : '#666',
                    fontWeight: 600,
                    textAlign: 'center',
                  }}
                >
                  {pct}%
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
